export default __webpack_public_path__ + "static/media/activecampaign.2397f428.png";